<section class="ai-agent-page" [class.ai-agent-page--embedded]="embeddedDesktop()">
  <header class="ai-agent-header">
    <div class="ai-agent-avatar" aria-hidden="true">
      <img src="/static_images/ic_ai_integrations.svg" alt="" />
    </div>
    <div class="ai-agent-heading">
      <h1>{{ i18n.t('aiAgent.title') }}</h1>
      <p>{{ i18n.t('aiAgent.subtitle') }}</p>
    </div>
  </header>

  <div class="ai-agent-messages" aria-live="polite">
    @for (message of messages(); track message.id) {
      <div class="agent-message" [class.agent-message--mine]="message.mine">
        @if (!message.mine) {
          <span class="agent-message-avatar" aria-hidden="true">
            <img src="/static_images/ic_ai_integrations.svg" alt="" />
          </span>
        }
        <p class="agent-message-bubble">{{ messageText(message) }}</p>
      </div>
    }
  </div>

  <div class="ai-agent-suggestions" [attr.aria-label]="i18n.t('aiAgent.quickActions')">
    @for (suggestion of suggestions; track suggestion) {
      <button type="button" class="ai-agent-chip" (click)="useSuggestion(suggestion)">
        {{ i18n.t(suggestion) }}
      </button>
    }
  </div>

  <form class="ai-agent-composer" (ngSubmit)="sendMessage()">
    <textarea
      name="message"
      rows="1"
      class="ai-agent-input"
      [ngModel]="draft()"
      [placeholder]="i18n.t('aiAgent.placeholder')"
      (ngModelChange)="onDraftChange($event)"></textarea>
    <button type="submit" class="ai-agent-send" [disabled]="!draft().trim()">
      <img src="/static_images/ic_send.svg" [alt]="i18n.t('aiAgent.send')" />
    </button>
  </form>
</section>
